// Extract year from date text
export function extractYear(dateText) {
  if (!dateText) return null
  const yearMatch = dateText.match(/\b(1\d{3}|2\d{3})\b/)
  return yearMatch ? yearMatch[1] : null
}

// Format date text
export function formatDate(dateText) {
  if (!dateText) return 'Unknown'
  return dateText
}

// Smart birth date formatting based on living status
export function formatBirthDate(birthEvent, isLiving) {
  if (!birthEvent || !birthEvent.date_text) return ''
  
  let displayDate
  let privacyNote = ''
  
  if (isLiving) {
    const year = extractYear(birthEvent.date_text)
    displayDate = year ? `Born: ${year}` : 'Born: (year private)'
    privacyNote = ' <span style="color: #999; font-size: 12px;" title="Full date hidden for privacy">🔒</span>'
  } else {
    displayDate = `Born: ${birthEvent.date_text}`
  }
  
  return `<div class="person-detail">${displayDate}${privacyNote}</div>`
}

// Format event date with privacy
export function formatEventDate(event, isLiving, userRole) {
  if (!event.date_text) return 'Date unknown'
  
  // Admin always sees full date
  if (userRole === 'admin') {
    return event.date_text
  }
  
  // For birth events of living people, show year only
  if (event.event_type === 'birth' && isLiving) {
    const year = extractYear(event.date_text)
    return year ? `${year} 🔒` : 'Date private'
  }
  
  // All other events show full date
  return event.date_text
}

// Get primary name from name array
export function getPrimaryName(names) {
  if (!names || names.length === 0) return 'Unknown'
  const primary = names.find(n => n.is_primary)
  return primary ? primary.full_name : names[0].full_name
}

// Get life dates for a person
export function getLifeDates(person) {
  if (!person.event) return ''
  const birth = person.event.find(e => e.event_type === 'birth')
  const death = person.event.find(e => e.event_type === 'death')
  
  const birthYear = birth ? extractYear(birth.date_text) : '?'
  const deathYear = death ? extractYear(death.date_text) : (person.is_living ? '' : '?')
  
  if (person.is_living) {
    return birthYear ? `b. ${birthYear}` : ''
  } else {
    return `${birthYear} - ${deathYear}`
  }
}

// Get access description for role
export function getAccessDescription(role) {
  const descriptions = {
    'viewer': '👁️ <strong>Viewer Access:</strong> Historical records only (deceased, born before 1950)',
    'family': '👨‍👩‍👧‍👦 <strong>Family Access:</strong> All family members including living relatives',
    'admin': '🔐 <strong>Admin Access:</strong> Full access + editing capabilities'
  }
  return descriptions[role] || ''
}
